// C.1 — Майор Ив (global_iv), архетип «Хилер-командир».
//
// xlsx v6 dsl_trigger1:
//   event: turn_end, target: ally_aoe_all, effect: heal, value: 1
//   condition: own_field_has_gsec_fighter
//   → В конце своего хода: если на поле есть хотя бы один Боец G-Sec,
//     все союзники +1 hp.
//
// xlsx v6 dsl_active (Ф2, 1× за матч):
//   target: ally_aoe_all, effect: buff_stats, value: 0/2/0, duration: permanent
//   → +2 max armor всем союзникам (с синхронным current.armor по
//     правилу армора в CLAUDE.md).

import { registerImplementedAbility } from '../../warn-unimplemented.js';
import { healUnit } from '../../livlife/heal.js';
import { applyPermanentBuff } from '../../../buffs.js';

export const HERO_ID = 'global_iv';
const GSEC_FIGHTER_ID = 'global_gsec_fighter';

function hasGSecOnField(player) {
  if (!player?.field) return false;
  for (const row of player.field) {
    if (!row) continue;
    for (const u of row) {
      if (u?.id === GSEC_FIGHTER_ID) return true;
    }
  }
  return false;
}

function getAllAlliedUnitsAndHero(player) {
  const result = [];
  if (player?.hero) result.push(player.hero);
  if (player?.field) {
    for (const row of player.field) {
      if (!row) continue;
      for (const u of row) {
        if (u && (!u.isAlive || u.isAlive())) result.push(u);
      }
    }
  }
  return result;
}

// Trigger в конце хода игрока за Ив.
export function ivOnEndOfTurn(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return;
  if (p.hero.current?.silenced) return;
  if (!hasGSecOnField(p)) return;

  const targets = getAllAlliedUnitsAndHero(p);
  for (const t of targets) {
    healUnit(state, t, 1, { id: HERO_ID, name_ru: 'Майор Ив' });
  }
}

// Активка Ф2.
export function ivActive(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return { ok: false, reason: 'wrong_hero' };
  if (p.heroActiveUsedThisMatch) return { ok: false, reason: 'already_used' };

  const targets = [];
  if (p.field) {
    for (const row of p.field) {
      if (!row) continue;
      for (const u of row) if (u && (!u.isAlive || u.isAlive())) targets.push(u);
    }
  }

  for (const t of targets) {
    applyPermanentBuff(state, t, { atk: 0, armor: 2, hp: 0 }, HERO_ID, 'Майор Ив');
  }
  p.heroActiveUsedThisMatch = true;
  if (state.log) {
    state.log.add(`🛡 Ив [${p.name}]: активка — +2 брони всем ${targets.length} союзникам`);
  }
  return { ok: true, applied: targets.length };
}

export function ivActiveAvailable(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsedThisMatch) return false;
  if (p.hero.current?.silenced) return false;
  return true;
}

registerImplementedAbility(HERO_ID, 'trigger', 'active');
